// A13 — THE FORM-DATE NORMALISER. Brief 65 (brief 50 §4), the tenth of the sixteen.
//
//   src/App.tsx:6214-6228@8fdbbd6c x src/views/CollectiveCaseView.tsx:2568-2582@8fdbbd6c  100.0%
//
// BYTE-IDENTICAL — proved by diffing the two fifteen-line regions, not by
// trusting the ratio. Nothing to parameterise, nothing to choose, and the
// signature is trivially the union of what both call sites pass.
//
// Normalize any `*Date` / `*date` string fields to yyyy-MM-dd so HTML date
// inputs render them. The API returns DateTime columns as full ISO strings
// (e.g. "2024-05-15T00:00:00.000Z"); <input type="date"> only accepts the
// date-only form and silently shows empty otherwise.
export const normFormDates = (o: any) => {
  if (!o || typeof o !== "object") return o;
  const r = { ...o };
  for (const k of Object.keys(r)) {
    // 209 §23 — `statusDate` is not a form's date: the server owns it (no body writes
    // it) and an undone conversion hands it back WHOLE (CaseModal's / CollectiveCaseView's
    // snapshot), so the form keeps the moment rather than its day.
    if (k === "statusDate") continue;
    const v = r[k];
    if (
      (/Date$/.test(k) || k === "date") &&
      typeof v === "string" &&
      v.length > 10 &&
      v.includes("T")
    )
      r[k] = v.slice(0, 10);
  }
  return r;
};
